module.exports = __webpack_public_path__ + "img/humain.9bfa63c6.png";